<template>
  <div>
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li class="is-active" data-tab="general" @click="change_active_tab">
          <a>
            <i class="info icon" aria-hidden="true"></i>
            <span>{{ $t("general") }}</span>
          </a>
        </li>
        <li data-tab="emitter" @click="change_active_tab">
          <a>
            <i class="user icon" aria-hidden="true"></i>
            <span>{{ $t("emitter") }}</span>
          </a>
        </li>
        <li data-tab="custom" @click="change_active_tab">
          <a>
            <i class="cogs icon" aria-hidden="true"></i>
            <span>{{ $t("custom") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="container" ref="contents">
      <div class="" data-tab="general">
        <div class="field">
          <label class="label">{{ $t("wsdl url") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.wsdl_url"
              placeholder="https://pruebasfel.g4sdocumenta.com/webservicefront/factwsfront.asmx?WSDL"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-server"></i>
            </span>
          </p>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("access number") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.access_number"
                  placeholder="319169175"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-key"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("user") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.user"
                  placeholder="TEST"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $t("requestor") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.requestor"
              placeholder="8A454..."
            />
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="is-hidden" data-tab="emitter">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("name") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.name"
                  placeholder="Modul"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("tradename") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.tradename"
                  placeholder="Modul"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("tax affiliation") }}</label>
              <div class="control">
                <div class="select">
                  <select class="ui dropdown" v-model="meta.tax_affiliation">
                    <option value="GEN">{{ $t("general") }}</option>
                    <option value="EXE">{{ $t("excent") }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("nit") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.nit"
                  placeholder="3952107-9"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-id-card"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="column is-two-fifths">
            <div class="field">
              <label class="label">{{ $t("email") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.email"
                  placeholder="fel@trade.com"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-envelope"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("establishment code") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.establishment_code"
                  placeholder="1"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-envelope"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("country") }}</label>
              <div class="control">
                <div class="select">
                  <select class="ui dropdown" v-model="meta.country">
                    <option value="GT">{{ $t("guatemala") }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("department") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.department"
                  placeholder="Guatemala"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("municipality") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.municipality"
                  placeholder="Guatemala"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-two-fifths">
            <div class="field">
              <label class="label">{{ $t("address") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.address"
                  placeholder="1 calle 2-33 zona 4"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-map-marker"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("zip code") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.zip_code"
                  placeholder="1"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("currency") }}</label>
              <div class="control">
                <div class="select">
                  <select class="ui dropdown" v-model="meta.currency">
                    <option value="GTQ">{{ $t("guatemalan quetzal") }}</option>
                    <option value="USD">
                      {{ $t("united states dollar") }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("adenda detail template id") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.adenda_detail_template_id"
                  placeholder=" "
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("adenda template id") }}</label>
              <p class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  v-model="meta.adenda_template_id"
                  placeholder=" "
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="is-hidden" data-tab="custom">
        <div class="buttons is-pulled-right">
          <div class="button is-secondary is-rounded" @click="add_phrase">
            <span class="icon">
              <i class="fa fa-plus"></i>
            </span>
            <span>{{ $t("add") }}</span>
          </div>
        </div>
        <h5 class="title is-5 pt-3">{{ $t("phrases") }}</h5>
        <table class="table is-bordered is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("phrase code") }}</th>
              <th>{{ $t("stage code") }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rsrc, ridx) in meta.phrases" :key="ridx">
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="meta.phrases[ridx].phrase_code"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="meta.phrases[ridx].stage_code"
                />
              </td>
              <td>
                <div
                  class="button is-secondary has-text-danger is-rounded"
                  @click="meta.phrases.splice(ridx, 1)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "G4s",
  data() {
    return {
      meta: { phrases: [] },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      let v = this;
      Object.keys(data).map((k) => {
        v.meta[k] = data[k];
      });
    },
    clear() {
      this.meta = {
        wsdl_url: "",
        access_number: "",
        user: "",
        requestor: "",
        name: "",
        tradename: "",
        tax_affiliation: "",
        nit: "",
        email: "",
        establishment_code: "",
        country: "",
        department: "",
        municipality: "",
        address: "",
        zip_code: "",
        currency: "",
        phrases: [],
      };
    },
    change_active_tab($event) {
      let v = this;
      let target = $event.target;
      let active_tab = "";
      if (target) active_tab = window.jQuery(target).closest("li").data("tab");
      if (active_tab) {
        /** Headers */
        window.jQuery(v.$refs.tabs).find("li").removeClass("is-active");
        window
          .jQuery(v.$refs.tabs)
          .find(`li[data-tab=${active_tab}]`)
          .addClass("is-active");

        /** Content */
        window.jQuery(v.$refs.contents).find(">div").addClass("is-hidden");
        // .attr("display", "none");
        window
          .jQuery(v.$refs.contents)
          .find(`div[data-tab=${active_tab}]`)
          .removeClass("is-hidden");
      }
    },
    add_phrase() {
      let v = this;
      v.meta.phrases.push({
        phrase_code: "",
        stage_code: "",
      });
    },
  },
};
</script>
